import axiosClient from "../../shared/components/requests/axiosCLient";
import { API_URLS } from "../../shared/constants/constants";

export const getFinanceAndLeasingLanding = () => {
  const url = API_URLS.financeAndLeasing;
  return axiosClient.get(url);
};
